





















































import {Vue, Component} from 'vue-property-decorator'
import {Mutation, State} from "vuex-class";
import {formatDate, formatDateTime, formatPrice} from "@/utils/formatters";
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import getConnection from "@/utils/signalr_connection";

@Component({name: "narudzbenice"})
export default class Narudzbenice extends mixins(ComponentBaseMixin) {
  @State menuCollapsed;
  @State user;
  @Mutation setMenuCollapsed;
  columns = [];
  merchandisers = [];
  fromDate = "";
  toDate = "";
  selectedMerchandiser = "";
  store: any = "";

  narudzbenice = [];
  tableOptions = {
    sortable: true,
    pagination: true,
    pageSize: 50,
    loadingFontSize: `${14}px`,
    search: true,
    showExport: true,
    exportTypes: ['excel'],
    detailView: true,
    detailFormatter: (ix, row, el) => this.details(ix, row, el)
  };
  isBusy = false;

  async created() {
    this.setMenuCollapsed(true);
    this.columns = [
      {field: 'number', title: this.$i18n.t('#'), sortable: true, formatter: (value, row) => `<a href="#/dokumenti/narudzbenice/${row.id}">${value}</a>`},
      {field: 'type', title: this.$i18n.t('tip'), sortable: true},
      {field: 'date', title: this.$i18n.t('datum'), sortable: true, formatter: formatDateTime},
      {field: 'storeName', title: this.$i18n.t('objekat'), sortable: true},
      {field: 'address', title: this.$i18n.t('adresa'), sortable: true},
      {field: 'city', title: this.$i18n.t('mesto'), sortable: true},
      {field: 'rebate', title: this.$i18n.t('rabat'), sortable: true},
      {field: 'dueDate', title: "Datum isporuke", sortable: true, formatter: formatDate},
      {field: 'createdBy', title: this.$i18n.t('kreator'), sortable: true,},
      {field: 'total', title: this.$i18n.t('total'), align: 'right', formatter: formatPrice},
      {field: 'status', title: this.$i18n.t('status'), formatter: this.formatStatus, width: '60px'}
    ];
    this.axios.get("api/GetUsers").then((result) => {
      this.merchandisers = result.data;
    });
    const connection = getConnection();
    connection.on('newOrderCreated', this.pretraziNarudzbenice);
  }

  async mounted() {
    let picker = $("#daterange");
    picker
        .daterangepicker({
          format: this.$i18n.t("DATE_FORMAT"),
          autoApply: true,
        })
        .data("daterangepicker")
        .setStartDate(new Date());

    $("#select2").select2({
      placeholder: "-",
      width: "100%",
      allowClear: true,
      minimumInputLength: 3,
      ajax: {
        url: "api/SearchStoresByName",
        data: function(term) {
          return { name: term.term || "" };
        },
        headers: {'X-User': this.user.id},
        processResults: function(data) {
          return {
            results: data.map(function(store) {
              return {
                id: store.id,
                text: `${store.name} (${store.city})`,
              };
            }),
          };
        },
      },
    });
  }

  async pretraziNarudzbenice() {
    if (this.isBusy) return;
    let picker = $("#daterange");
    this.fromDate = picker
        .data("daterangepicker")
        .startDate.format("YYYY-MM-DD");
    this.toDate = picker
        .data("daterangepicker")
        .endDate.format("YYYY-MM-DD");
    this.store = $("#select2").select2("val");

    this.narudzbenice = [];
    let table = $('#table');
    table.bootstrapTable('showLoading');
    this.isBusy = true;
    try {
      const { data } = await this.axios.get('api/GetOrders', {params: {
          fromDate: this.fromDate,
          toDate: this.toDate,
          creator: this.selectedMerchandiser,
          store: this.store
      }});
      this.narudzbenice = data;
    } catch(err) {
      this.showError('neuspesnoUcitavanjePodataka');
      this.isBusy = false;
      table.bootstrapTable('hideLoading');
    } finally {
      this.isBusy = false;
      table.bootstrapTable('hideLoading');
    }
  }

  details(ix, row, el) {
    return $("<table>").bootstrapTable({
      columns: [
        {field: 'product', title: "Artikal", align: 'left'},
        {field: 'quantity', title: "Kol", align: 'right', formatter: formatPrice},
        {field: 'price', title: "Cena", align: 'right', formatter: formatPrice},
        {field: 'total', title: "Ukupno", align: 'right', formatter: formatPrice},
      ],
      data: row.items
    });
  }

  private formatStatus(value, row) {
    let color = '';
    switch (value) {
      case "Stornirana": color = 'bgc-red-d1';break;
      case "Realizovana": color = 'bgc-green-d1';break;
      default: color = 'bgc-orange-d1';break;
    }
    return `<span class="badge text-white ${color} badge-pill px-25">${value}</span>`;
  }

  destroyed() {
    getConnection().off('newOrderCreated', this.pretraziNarudzbenice);
  }
}
